export default __webpack_public_path__ + "static/media/srboiNgirl_w640.5d056387.jpeg";